import { first, map, Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AADCallbackGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.checkAADAuth().pipe(
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.router.navigateByUrl('auth/login');
        } else {
          const url = this.authService.popTmpUrl() || '/';
          this.router.navigateByUrl(url);
        }
        return isAuthenticated;
      }),
      map((res) => !!res),
      first(),
    );
  }
}
